import { z } from 'zod';
import { Auction, AuctionSchema } from '@/types/auction/auction.type.ts';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';
import { AuctionStatus } from '@/types/auction/auction-status.type.ts';
import { CarTransmissionType } from '@/types/car.type.ts';

export type CarLastAuctionListItem = {
    car_id: number,
    last_lot: {
        id: number,
        start_price: number,
        start_date: string,
        end_date: string,
        winner: {
            dealer_id: number | null,
            dealer_name: string | null,
            bid_value: number | null,
        },
    } | null,
};

export type AuctionsPaginator = {
    data: Auction[],
    meta: PaginationMeta,
};

export type AuctionsRequestFilter = {
    brand_ids?: number[],
    model_ids?: number[],
    from_date?: string,
    to_date?: string,
    status?: AuctionStatus[],
    start_price: [number, number],
    transmission_type?: CarTransmissionType[],
    mileage: [number, number],
    production_year: [number, number],
    city_ids?: number[],
    dealer_ids?: number[],
    confirmation_required?: 0 | 1,
    joining?: 0 | 1,
    sort?: Record<string, 'asc' | 'desc'>[],
    page?: number,
};

export type JoiningAuctionsRequestFilter = {
    brand_id?: number[],
    model_id?: number[],
    from_date?: string,
    to_date?: string,
    status?: AuctionStatus[],
    sort?: Record<string, 'asc' | 'desc'>[],
    page?: number,
};

export type InProgressAuctionBroadcastItem = {
    lot_id: number,
    last_bid: {
        value: number,
    } | null,
    bids_count: number,
    seconds_to_end: number,
};

export type AuctionStatusBroadcast = {
    lot_id: number,
    status: AuctionStatus,
};

export const CarLastAuctionListItemSchema = z.object({
    car_id: z.number(),
    last_lot: z.object({
        id: z.number(),
        start_price: z.number(),
        start_date: z.string(),
        end_date: z.string(),
        winner: z.object({
            dealer_id: z.number().nullable(),
            dealer_name: z.string().nullable(),
            bid_value: z.number().nullable(),
        }),
    }).nullable(),
});

export const CarLastAuctionListSchema = z.array(CarLastAuctionListItemSchema);

export const AuctionsPaginatorSchema = z.object({
    data: z.array(AuctionSchema),
    meta: PaginationMetaSchema,
});

export const InProgressAuctionBroadcastItemSchema = z.object({
    lot_id: z.number(),
    last_bid: z.object({
        value: z.number(),
    }).nullable(),
    bids_count: z.number(),
    seconds_to_end: z.number(),
});

export const InProgressAuctionsBroadcastSchema = z.array(InProgressAuctionBroadcastItemSchema);

export const AuctionStatusBroadcastSchema = z.object({
    lot_id: z.number(),
    status: z.nativeEnum(AuctionStatus),
});
